module.exports = __webpack_public_path__ + "static/img/qrcode.b184fd57.jpg";